import { useEffect, useState } from "react";
import RequiredMark from "../../../ui/new_components/common/required_mark";
import { dataTypes } from "../../../utils/import_export_parser";
import { defaultKazamGST, KazamGST } from "../models/gst_model";
import { updateObject } from "../../../utils/formDataToJson";
import moment from "moment";
import { getFileType } from "../../purchase_order/model/purchase_order_model";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import { FileType, indianStates } from "../../../utils/enums";
import { GetGSTRepoByID } from "./repo/gst_repo";
import { useHistory, useParams } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import "../../../styles/responsive_shrink.css";
import { Clock } from "react-feather";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";

const GstDetailScreen = () => {
  const { id } = useParams<{ id: string }>();
  const { showToast } = useToast();
  const [kazamGst, setKazamGst] = useState<KazamGST>(defaultKazamGST);
  const [loading, setLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const navigation = useHistory();

  const getData = async (id: string) => {
    setLoading(true);
    const res = await GetGSTRepoByID(id);
    if (res.success) {
      setKazamGst(res.data);
      setLoading(false);
    } else showToast({ type: ToastType.error, text: res.error });
    setLoading(false);
  };

  useEffect(() => {
    if (id) getData(id);
  }, []);

  const handleChange = (e: any) => {
    const { value, name } = e.target;
    const type = e.target.getAttribute("data-type");

    const keys = name.split(".");
    const updatedValue = updateObject(kazamGst, keys, value, type);
    setKazamGst(updatedValue);
  };

  return (
    <div className="mobile-shrink">
      <form
        id="gst_create_form"
        onSubmit={() => {}}
        action="submit"
        method="POST"
        className="grid gap-2 p-2 md:p-5"
      >
        {" "}
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold border-l-4 border-myPrimaryColor pl-2">
            Kazam GST Details
          </h1>
          <button
            id="history_btn"
            type="button"
            onClick={() => setShowHistory(true)}
            className="flex items-center gap-1 text-sm hover:text-gray-600  text-myPrimaryColor"
            title="View History"
          >
            <Clock size={32} />
          </button>
        </div>
        <fieldset disabled>
          <div className="bg-white rounded-md p-3 md:p-4 w-full">
            <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 w-full md:w-1/2">
              <div className="grid gap-1">
                <label htmlFor="gst_number" className="text-sm font-semibold">
                  GST Number <RequiredMark />
                </label>
                <input
                  required
                  className="border rounded-md px-3 py-1 w-full"
                  type="text"
                  data-type={dataTypes.string}
                  id="gst_number"
                  name="gst_number"
                  value={kazamGst.gst_number}
                  onChange={handleChange}
                />
              </div>
              <div className="grid gap-1">
                <label htmlFor="name" className="text-sm font-semibold">
                  Name <RequiredMark />
                </label>
                <input
                  required
                  className="border rounded-md px-3 py-1 w-full"
                  type="text"
                  data-type={dataTypes.string}
                  id="name"
                  name="name"
                  value={kazamGst.name}
                  onChange={handleChange}
                />
              </div>
              <div className="grid gap-1">
                <label
                  htmlFor="address.state"
                  className="text-sm font-semibold"
                >
                  State <RequiredMark />
                </label>

                <select
                  id="address.state"
                  name="address.state"
                  className="p-1 rounded focus:outline-none w-full border"
                  value={kazamGst.address.state || ""}
                  data-type={dataTypes.string}
                  onChange={handleChange}
                >
                  <option value="">Select State</option>
                  {indianStates.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
              <div className="grid gap-1">
                <label htmlFor="address.city" className="text-sm font-semibold">
                  City <RequiredMark />
                </label>
                <input
                  required
                  className="border rounded-md px-3 py-1 w-full"
                  type="text"
                  data-type={dataTypes.string}
                  id="address.city"
                  name="address.city"
                  value={kazamGst.address.city}
                  onChange={handleChange}
                />
              </div>
              {/* Address */}
              <div className="grid grid-cols-1">
                <div className="grid gap-1">
                  <label
                    htmlFor="address.line1"
                    className="text-sm font-semibold"
                  >
                    Address Line 1 <RequiredMark />
                  </label>
                  <input
                    required
                    className="border rounded-md px-3 py-1 w-full"
                    type="text"
                    data-type={dataTypes.string}
                    id="address.line1"
                    name="address.line1"
                    value={kazamGst.address.line1}
                    onChange={handleChange}
                  />
                </div>
                <div className="grid grid-cols-1">
                  <div className="grid gap-1 my-5">
                    <label
                      htmlFor="address.line2"
                      className="text-sm font-semibold"
                    >
                      Line 2 <RequiredMark />
                    </label>
                    <input
                      required
                      className="border rounded-md px-3 py-1 w-full"
                      type="text"
                      data-type={dataTypes.string}
                      id="address.line2"
                      name="address.line2"
                      value={kazamGst.address.line2}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="grid gap-1">
                    <label
                      htmlFor="address.line3"
                      className="text-sm font-semibold"
                    >
                      Line 3
                    </label>
                    <input
                      className="border rounded-md px-3 py-1 w-"
                      type="text"
                      data-type={dataTypes.string}
                      id="address.line3"
                      name="address.line3"
                      value={kazamGst.address.line3}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="grid gap-1 self-start">
                <label
                  htmlFor="address.country"
                  className="text-sm font-semibold"
                >
                  Country <RequiredMark />
                </label>
                <input
                  required
                  disabled
                  className="border rounded-md px-3 py-1 w-full"
                  type="text"
                  data-type={dataTypes.string}
                  id="address.country"
                  name="address.country"
                  value={kazamGst.address.country}
                  onChange={handleChange}
                />
              </div>
              <div className="grid gap-1 self-start">
                <label
                  htmlFor="address.pincode"
                  className="text-sm font-semibold"
                >
                  Pincode <RequiredMark />
                </label>
                <input
                  required
                  className="border rounded-md px-3 py-1 w-full"
                  type="text"
                  data-type={dataTypes.string}
                  id="address.pincode"
                  name="address.pincode"
                  value={kazamGst.address.pincode}
                  onChange={handleChange}
                />
              </div>
              <div className="grid gap-1 self-start">
                <label
                  htmlFor="effective_date_of_reg"
                  className="text-sm font-semibold"
                >
                  Effective date of registration <RequiredMark />
                </label>
                <input
                  required
                  className="border rounded-md px-3 py-1 w-full"
                  type="date"
                  id="effective_date_of_reg"
                  name="effective_date_of_reg"
                  value={moment(kazamGst.effective_date_of_reg).format(
                    "YYYY-MM-DD",
                  )}
                  onChange={handleChange}
                />
              </div>
            </section>
            <div className="grid gap-1 self-start w-full md:w-1/2 my-5">
              <label
                htmlFor="effective_date_of_reg"
                className="text-sm font-semibold"
              >
                Attachments <RequiredMark />
              </label>
              <div className="my-2 space-y-4 max-h-96 overflow-y-auto">
                {kazamGst?.attachments?.map((fileObj) => (
                  <div
                    key={fileObj.id}
                    id={`gst_attachment_row_${fileObj.id}`}
                    className="flex items-center justify-between p-3 border rounded-md"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      {getFileType(fileObj.type) === FileType.IMAGE ? (
                        <img
                          src={fileObj.url}
                          alt=""
                          className="w-16 h-16 object-cover"
                        />
                      ) : (
                        <a
                          href={fileObj.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm break-all"
                        >
                          {fileObj.url.split("/").pop()}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </fieldset>
        <div className="flex justify-end gap-2 my-4">
          <button
            id="quit_btn"
            onClick={() => {
              navigation.goBack();
            }}
            type="button"
            className="rounded-md border border-green-600 text-sm font-semibold bg-white text-black px-3 py-1"
          >
            Quit
          </button>
        </div>
      </form>
      {loading && <LoadingWidget />}
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory}
          onClose={() => setShowHistory(false)}
          title="Kazam GST History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "kazam gst",
                entityId: id,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
    </div>
  );
};

export default GstDetailScreen;
